export type CustomerPortalLogoSizeInput = string | number | null | undefined;

export const DEFAULT_CUSTOMER_PORTAL_LOGO_SIZE = 50;
export const MIN_CUSTOMER_PORTAL_LOGO_SIZE = 20;
export const MAX_CUSTOMER_PORTAL_LOGO_SIZE = 80;

export const normalizeCustomerPortalLogoSize = (size: CustomerPortalLogoSizeInput): number => {
  if (size === undefined || size === null) return DEFAULT_CUSTOMER_PORTAL_LOGO_SIZE;

  if (typeof size === 'number') {
    return Number.isFinite(size) &&
      size >= MIN_CUSTOMER_PORTAL_LOGO_SIZE &&
      size <= MAX_CUSTOMER_PORTAL_LOGO_SIZE
      ? size
      : DEFAULT_CUSTOMER_PORTAL_LOGO_SIZE;
  }

  const trimmedSize = size.trim();
  const parsedNumber = Number(trimmedSize);
  if (
    Number.isFinite(parsedNumber) &&
    parsedNumber >= MIN_CUSTOMER_PORTAL_LOGO_SIZE &&
    parsedNumber <= MAX_CUSTOMER_PORTAL_LOGO_SIZE
  ) {
    return parsedNumber;
  }

  const sizeMap: Record<string, number> = {
    small: 30,
    medium: DEFAULT_CUSTOMER_PORTAL_LOGO_SIZE,
    large: MAX_CUSTOMER_PORTAL_LOGO_SIZE,
  };

  return sizeMap[trimmedSize.toLowerCase()] ?? DEFAULT_CUSTOMER_PORTAL_LOGO_SIZE;
};

export const getCustomerPortalLogoSizeStyles = (size: CustomerPortalLogoSizeInput) => {
  const normalizedSize = normalizeCustomerPortalLogoSize(size);
  const maxWidth = 400;
  const width = (maxWidth * normalizedSize) / 100;

  return {
    width: `${width}px`,
    height: 'auto',
    maxWidth: '100%',
  };
};
